import React from 'react';

import { useSearchResults } from '../../hooks';
import { SCOPE_ARTICLES, SCOPE_DIRECTORY, SCOPE_FORUM } from '../../hooks/useSearchResults';
import { search_page_path } from '../../routes';
import { CustomToaster, Pagination, Spinner } from '../BaseUI';
import { PaginationType } from '../BaseUI/Pagination';
import { ExploreEntities, SearchBar } from '../shared';
import SearchArticlesList from './SearchArticlesList';
import SearchHeader from './SearchHeader';
import SearchPostsList from './SearchPostsList';
import SearchSubscribersList from './SearchSubscribersList';
import SearchTabs from './SearchTabs';
import { SearchPageProps } from './index';
import styles from './styles.module.scss';

const Layout = ({
  articleContent,
  customBlurb,
  followCount,
  followers,
  followStatus,
  isSignedIn,
  matchingEntity,
  page,
  query,
  scope,
  title,
  topEntities,
  topicOrAuthorLink,
  topRelatedEntities,
}: SearchPageProps) => {
  const { data, isLoading } = useSearchResults(page, query, scope);

  if (isLoading) {
    return <Spinner />;
  }

  const isSearchLandingPage = !query && topEntities;
  const isArticleScope = scope === SCOPE_ARTICLES;
  const isForumScope = scope === SCOPE_FORUM;
  const isDirectoryScope = scope === SCOPE_DIRECTORY;

  const totalPages = isArticleScope ? articleContent.totalPages : data?.totalPages ?? 1;

  const paginationData: PaginationType = {
    page,
    totalPages: totalPages,
    hasNextPage: page < totalPages,
    nextPage: page + 1,
  };

  return (
    <>
      <CustomToaster />
      <SearchBar
        isSearchLandingPage={isSearchLandingPage}
        placeholder={`Search ${scope || SCOPE_ARTICLES}`}
        scope={scope}
      />
      {isSearchLandingPage && <ExploreEntities entities={topEntities} isSignedIn={isSignedIn} />}
      {!!query && (
        <>
          <SearchHeader
            customBlurb={customBlurb}
            followCount={followCount}
            followers={followers}
            followStatus={followStatus}
            isSignedIn={isSignedIn}
            matchingEntity={matchingEntity}
            title={title}
            topicOrAuthorLink={topicOrAuthorLink}
            topRelatedEntities={topRelatedEntities}
          />
          <SearchTabs query={query} scope={scope} />
          <div className={styles.feedSection}>
            {isArticleScope && <SearchArticlesList content={articleContent} />}
            {isForumScope && <SearchPostsList content={data.forum_posts} />}
            {isDirectoryScope && (
              <SearchSubscribersList
                content={{
                  profiles: data?.profiles,
                  currentUserId: data?.currentUserId,
                }}
              />
            )}
          </div>
          {totalPages > 1 && (
            <Pagination
              getPath={(page) => search_page_path({ query, scope, page })}
              paginationData={paginationData}
            />
          )}
        </>
      )}
    </>
  );
};

export default Layout;
